/* tslint:disable */
/* eslint-disable */
export enum WorkAccountingExportEntityTypeEnum {
  Voucher = 'voucher',
  JournalEntry = 'journal_entry',
  OpenItem = 'open_item',
  AccountingPartner = 'accounting_partner'
}
